import  axiosClient  from "../axiosClient";

export function loginValidation(data){
    return axiosClient.post('/cc/login', JSON.stringify(data));
}

export function getCcDecrypt(data){
    let bearerTokenHeader = sessionStorage.getItem('token');
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
    return axiosClient.post('/cc/auth', JSON.stringify(data));
}

// const bearerTokenHeader = {
        
//     headers: { "Authorization": `Bearer ${infoState.AccessToken}` }
// };